module.exports = __webpack_public_path__ + "img/casino.53089e5a.png";